import React, { Component, Fragment } from 'react';
import { PulseLoader, ScaleLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { VelocityComponent } from 'velocity-react';
import Img from 'react-image';
import * as stateActions from './../../../store/actions';
import { NavLink } from 'react-router-dom';
import './GameScreen.scss';
import Icons from './../../../assets/Icons/Icons';
import AuthenticationButton from "../../Menu/MainMenu/AuthenticationMenu/AuthenticationButton/AuthenticationButton";
import { withTranslation } from "react-i18next";
import IFrame from "react-iframe";
import DinamicImage from "../../Utils/DinamicImage/DinamicImage";
import { withRouter } from "react-router";

import HappyHoursMobile from "../../HappyHours/views/index-mobile";
import HappyHoursWin from "../../HappyHours/views/win-panel";
import HappyHoursEnded from "../../HappyHours/views/final";
import HappyHoursInfo from "../../HappyHours/views/info";

import { getText, styleToObj, itemThumbnail } from "../../../lobby/utils/functions";
import axios from "axios";
import { loadedGames } from "../../../lobby/store/actions/games";

let intervalID = 0;

const apiURL = process.env.CFW.betsApiUrl + "/casinoapi/config/games/" + window.config.clientId + "?platformType=" + window.config.platformType;

class GameScreen extends Component {

    constructor(props) {
        super(props);

        this.urlPath = window.config.front_url;
        this.cdnGamesUrl = window.location.protocol + '//' + window.config.cdn_address + '/' + window.config.cdn_games_path + '/';
        this.imageGameType = '.png';
        this.bgPath = this.urlPath + '/img/bg_launchgame.jpg';

        this.state = { isCollapsed: false, changed: 0, innerWidth: window.innerWidth, innerHeight: window.innerHeight };
    }

    componentDidMount() {
        let url = window.location.pathname.split('/');

        if (typeof url === 'object' && typeof url[1] !== 'undefined' && url[1] === 'play') {
            this.props.onOpenGame(url[2]);
        }
        this.attachEventListener();
        intervalID = setInterval(() => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            this.setState(s => {
                if (s.innerWidth !== width || s.innerHeight !== height) {
                    return {
                        isCollapsed: s.isCollapsed,
                        changed: s.changed + 1,
                        innerHeight: height,
                        innerWidth: width
                    };
                }
                return s;
            });
        }, 500);
        if (!this.props.lobbyGames.length) {
            axios.get(apiURL)
                .then(response => {
                    if (response && response.data) {
                        this.props.loadedGames(response.data);
                    }
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location && this.props.location && prevProps.location.pathname !== this.props.location.pathname) {

            if (prevProps.location.pathname.indexOf("/play/") > -1 && this.props.location.pathname.indexOf("/play/") > -1) {
                let url = this.props.location.pathname.split('/');
                if (!this.props.games.actualGame || !this.props.games.actualGame.game_id.toString() !== url[2]) {
                    this.props.onOpenGame(url[2]);
                }
            }
        }
    }

    componentWillUnmount() {
        this.removeEventListeners();
        clearInterval(intervalID);
    }

    attachEventListener() {
        window.addEventListener("message", this.egtReceivedMessage.bind(this), false);
        window.addEventListener("message", this.greentubeReceivedMessage.bind(this), false);
    }

    removeEventListeners() {
        window.removeEventListener("message", this.egtReceivedMessage.bind(this));
        window.removeEventListener("message", this.greentubeReceivedMessage.bind(this));
    }

    greentubeReceivedMessage(event) {

        if (!event.data) {
            return;
        }
        let data = '';
        try {
            data = JSON.parse(event.data);

        } catch (e) {
            return false;
        }


        if (typeof data.event !== "undefined") {
            if ('gameClosing' === data.event.name) {
                return this.closeHandler();
            }
        }
    }

    launchGameByProviderGameId = (providerGameId) => {
        let game = this.props.lobbyGames.find((element) => {

            if (element.provider_game_id === providerGameId) {
                return true
            }
            return false;
        });
        if (game && game.game_id) {
            this.props.history.push('/play/' + game.game_id);
            this.props.onOpenGame(game.game_id);
        } else {
            this.closeHandler();
        }
    }

    egtReceivedMessage(event) {

        if (!event.data) {
            return;
        }

        if (!event.data.hasOwnProperty('command')) {
            return;
        }

        if ('com.egt-bg.exit' === event.data.command || "com.egt-bg.launchLobby" === event.data.command) {
            return this.closeHandler();
        }

        if ('com.egt-bg.reload' === event.data.command) {
            // reload game
            if (!this.props.games.actualGame) {
                console.error(`[GAME] Actual game is empty!`);
                return;
            }

            if (!this.props.games.actualGame.id) {
                console.error(`[GAME] Actual game has no ID!`);
                return;
            }

            return this.props.reload(this.props.games.actualGame.id);
        }

        if ("com.egt-bg.launchGame" === event.data.command) {
            try {
                let providerGameId = event.data.gin;
                if (window.loadedGame && window.loadedGame !== providerGameId) {
                    // switch functionality from EGT game
                    this.props.onCloseGame(false);
                    window.loadedGame = false;
                    return this.launchGameByProviderGameId(providerGameId);
                } else {
                    window.loadedGame = providerGameId;
                }
            } catch (e) { }
        }
    }

    closeHandler(openLogin = false) {

        if (openLogin) {

            this.props.history.goBack();
        } else {
            this.props.history.push("/cazino/jocuri");
        }
        // if (this.props.history.length) {
        //     this.props.history.goBack();
        // } else {
        //     this.props.history.history.push("/cazino/jocuri");
        // }
        if (["user", "token"].indexOf(this.props.authentication.auth_type) > -1) {
            this.props.reloadWallet();
        }
        window.loadedGame = false;
        this.props.onCloseGame(openLogin);
    }

    getGameElement() {
        let gameElement = "";
        if (this.props.games.hasErrors) {
            gameElement = this.guestLogin();
            return gameElement;
        }

        if (null !== this.props.games.link) {
            gameElement = (<VelocityComponent animation={(!this.props.games.showLoading) ? { opacity: 1 } : { opacity: 0 }} duration={500} runOnMount={true}>
                <object
                    width="100%"
                    height="100%"
                    data={this.props.games.link}
                    onLoad={this.contentLoaded.bind(this)}
                    onError={this.contentError.bind(this)}
                    className="flash-game"
                >
                    casino game
                </object>
            </VelocityComponent>);
        }

        return gameElement;
    }

    clickHandler() {
        this.closeHandler();
        this.props.onPageChanged('register');
    }

    getGameElementIFrame() {
        let gameElement = "";
        if (this.props.games.hasErrors) {
            gameElement = this.guestLogin();
            return gameElement;
        }

        if (null !== this.props.games.link) {

            let width = window.innerWidth;
            let height = window.innerHeight;

            let w = 960;
            let h = 540;
            let ratio = w / h;
            let innerHeight = window.innerHeight - (this.props.hhRunning && this.state.isCollapsed ? 92 : 50);
            width = innerHeight * ratio;
            height = innerHeight;
            if (this.props.hhRunning && !this.state.isCollapsed && width + 140 > window.innerWidth) {
                width = window.innerWidth - 140;
                height = width / ratio;
            }

            gameElement = (<VelocityComponent animation={(!this.props.games.showLoading) ? { opacity: 1 } : { opacity: 0 }} duration={500} runOnMount={true}>
                <IFrame
                    width={width}
                    height={height}
                    url={this.props.games.link}
                    onLoad={this.contentLoaded.bind(this)}
                    onError={this.contentError.bind(this)}
                    className="flash-game"
                    // allowFullScreen
                    autoPlay
                    allow={"autoplay; fullscreen"} />
            </VelocityComponent>);
        }

        return gameElement;
    }

    guestLogin() {
        let actualGameImage = <Fragment />;
        let actualGameTitle = <Fragment />;
        if (this.props.games.actualGame) {
            if (this.props.games.actualGame.name) {
                /* PO-5429 */
                if (this.props.games.actualGame.provider && this.props.games.actualGame.name) {
                    const img = itemThumbnail({ providerId: this.props.games.actualGame.provider, name: this.props.games.actualGame.name, type: "slot_game" });
                    if (img) {
                        this.props.games.actualGame.img = img;
                    }
                }

                actualGameImage = <DinamicImage
                    folder={"games"}
                    size={"small"}
                    imgName={this.props.games.actualGame.name !== null ? this.props.games.actualGame.name.replace(/\s/g, "-").toLowerCase() + ".jpg" : "game-placeholder.jpg"}
                    title={this.props.games.actualGame.name !== null ? this.props.games.actualGame.name + ' (' + this.props.games.actualGame.name.replace(/\s/g, "-").toLowerCase() + ".jpg" + ')' : "slot games"}
                    imgLink={this.props.games.actualGame.img ? this.props.games.actualGame.img : null}
                    className={'actualGameImage'}
                />
                actualGameTitle = <h1 className={'actualGameTitle'}>{this.props.games.actualGame.name}</h1>;
            }
        }

        let storedGame = null;
        let ui = {};

        if (this.props.games.actualGame) {
            const game = this.props.games.actualGame;
            storedGame = this.props.lobbyGames.find(g => g.game_id === game.game_id);
            if (storedGame && storedGame.ui) ui = storedGame.ui;
        }

        let lang = this.props.i18n.language;
        let wrapperStyle = {};
        let imageStyle = {};
        let hasShortDescription = false;
        let hasLongDescription = false;

        const texts = {}

        if (ui && Object.keys(ui).length) {
            imageStyle = { backgroundImage: `url(${window.config.front_url}/img/mobile/home/jackpot_bg.png)` };
            try {
                wrapperStyle = styleToObj(ui && ui.background_image && ui.background_image.style ? ui.background_image.style : "");
                if (ui && ui.background_image && ui.background_image.url && ui.background_image.url.toLowerCase().indexOf("http") === 0) {
                    imageStyle.backgroundImage = `url("${ui.background_image.url}")`;
                }

                texts["long_description"] = getText(ui, `long_description.text.${lang}`, "");
                texts["long_description_style"] = styleToObj(ui && ui.long_description && ui.long_description.style ? ui.long_description.style : "");
                texts["long_description_title"] = getText(ui, `long_description_title.text.${lang}`, "");
                texts["long_description_title_style"] = styleToObj(ui && ui.long_description_title && ui.long_description_title.style ? ui.long_description_title.style : "");
                texts["short_description"] = getText(ui, `short_description.text.${lang}`, "");
                texts["short_description_style"] = styleToObj(ui && ui.short_description && ui.short_description.style ? ui.short_description.style : "");

                if (texts["short_description"]) hasShortDescription = true;
                if (texts["long_description"]) hasLongDescription = true;

            } catch (err) {/* noop */ }
        }


        return (
            <div className={`guestLogin ${hasShortDescription ? "withDescription" : ""}`} style={wrapperStyle}>
                <div className="bg" style={imageStyle}>
                    {!hasShortDescription && <Fragment>
                        {actualGameImage}
                        {actualGameTitle}
                    </Fragment>}
                    {hasShortDescription && <div className="base" style={texts["short_description_style"]}>
                        <div className="infoArea">
                            <div>
                                <div className="rich-text" dangerouslySetInnerHTML={{
                                    __html: texts["short_description"]
                                }} />
                            </div>
                            <div className={"rightSide"}>
                                <div className="icon-wrapper">
                                    {actualGameImage}
                                </div>
                            </div>
                        </div>
                        {actualGameTitle}
                    </div>}
                    <div className="px-1 account-button">
                        <NavLink to={"/register"} onClick={this.clickHandler.bind(this)}>
                            <button className={"text-uppercase font-weight-bold btn btn-warning register"}>
                                <span className="txt">{this.props.t("register")}</span>
                            </button>
                        </NavLink>
                    </div>
                    <AuthenticationButton btype="login" beforeOnClick={this.closeHandler.bind(this, true)} />

                    {hasLongDescription && <div className="longDescription">
                        <div className="description-title rich-text" style={texts["long_description_title_style"]} dangerouslySetInnerHTML={{
                            __html: texts["long_description_title"]
                        }} />
                        <div className="description-text rich-text" style={texts["long_description_style"]} dangerouslySetInnerHTML={{
                            __html: texts["long_description"]
                        }} />
                    </div>}
                </div>
            </div>
        );
    }

    contentLoaded() {
        // console.log(`[OBJECT ELEMENT] Content loaded for element object`);
        this.props.closeLoader();
    }

    contentError() {
        this.props.onError();
    }

    handleHHChange(collapsed) {
        this.setState({
            isCollapsed: collapsed
        });
    }

    render() {
        // let gameElement = this.getGameElement();
        let gameElement = this.getGameElementIFrame();
        let gameLoading = <VelocityComponent animation={(this.props.games.showLoading) ? { opacity: 1 } : { opacity: 0 }} duration={1000} runOnMount={true}>
            <PulseLoader className="gameScreenLoader" />
        </VelocityComponent>;

        let gameTitle, gameId = "";
        if (this.props.games.actualGame != null) {
            gameTitle = this.props.games.actualGame.name;
            gameId = this.props.games.actualGame.id;
        }

        let closeIcon = Icons.get("close-button", "closeScreenGame");

        let url = window.location.pathname.split('/');

        if (this.props.games.actualGame != null) {
            document.getElementsByTagName('html')[0].classList.add("OverflowHidden");
        } else {
            document.getElementsByTagName('html')[0].classList.remove("OverflowHidden");
        }

        const bgStyle = {
            background: this.props.gamesColors && this.props.gamesColors[gameId]
                ? this.props.gamesColors[gameId]
                : this.props.gamesColors && this.props.gamesColors["default"]
                    ? this.props.gamesColors["default"]
                    : "#000000"
        };

        return (
            <VelocityComponent animation={(this.props.games.actualGame != null) ? { opacity: 1, width: '100%', height: '100%', top: 0, left: 0 } : { opacity: 0, width: '100%', height: '100%' }}
                duration={500}
                runOnMount={false}
            >
                <div
                    className="GameScreen"
                    style={
                        (this.props.games.actualGame != null) ? { display: 'flex', top: this.props.games.top + 'px', left: this.props.games.left + 'px' } : (false === this.props.games.closed) ? { display: 'block', width: '100%', height: '100%' } : { display: 'none' }
                    }
                    key={gameId}
                >
                    <div className="GameScreenBg" style={{ backgroundImage: 'url("' + this.bgPath + '")' }} />
                    <div className="screen-title2">
                        <h5>{gameTitle}</h5>
                        <button type="button" className="close" onClick={this.closeHandler.bind(this)}>
                            <span aria-hidden="true">{closeIcon}</span>
                        </button>
                    </div>
                    <div className="screen-body">
                        {gameLoading}
                        <div className={`re-flow ${this.state.isCollapsed ? "column" : ""}`} style={bgStyle}>
                            <div className="hp">
                                {this.props.games.actualGame != null && <HappyHoursMobile onChange={this.handleHHChange.bind(this)} />}
                            </div>
                            <div className="if">
                                {gameElement}
                            </div>
                            {this.props.games.actualGame != null &&
                                <React.Fragment>
                                    <HappyHoursInfo />
                                    <HappyHoursWin />
                                    <HappyHoursEnded />
                                </React.Fragment>}
                        </div>
                    </div>
                </div>
            </VelocityComponent>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onCloseGame: (openLogin) => dispatch(stateActions.closeGame(openLogin)),
        closeLoader: () => dispatch(stateActions.hideGameLoader()),
        onError: () => dispatch(stateActions.gameError()),
        reloadWallet: () => dispatch(stateActions.requestWalletPreview()),
        reload: (gameId) => dispatch(stateActions.requestGameUrl(gameId)),
        onPageChanged: (page) => dispatch(stateActions.changePage(page)),
        onOpenGame: (game, x, y) => dispatch(stateActions.openGame({ id: game }, 0, 0)),
        loadedGames: (data) => dispatch(loadedGames(data)),
    };
};

const mapStateToProps = state => {
    // console.log(`[CLOSED] Status for closed is: ${(true === state.games.closed) ? 'true' : 'false'}`);
    return {
        games: state.games,
        authentication: state.authentication,
        gamesColors: state.config.gamesColors,
        hhRunning: state.happyHour.running,
        lobbyGames: state.lobby ? state.lobby.games.items : [],
    }
};

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(GameScreen)));
